<template>
    <div>
        <span>{{filter.values.aviation_ranks.map(rank=>rank.label).join(', ')}}</span>
    </div>
</template>
<script>
  export default {
    props: {
      filter: Object
    },
    name: 'aviationRankParams'
  }
</script>
<style>
</style>
